import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { FiDisplayType } from '@fi-shared/types/display-type';

@Component({
    selector: 'fi-user-list-container-dialog',
    template: `
        <fi-user-list
            [userListViewSettings]="data"
            [listDisplayType]="FiDisplayType.List"
            [hasCheckedColumn]="false"
            [hideActions]="true"
        >
        </fi-user-list>
    `,
    styleUrls: ['./fi-user-list-container-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-list-container-dialog' },
    standalone: false,
})
export class FiUserListContainerDialogComponent extends FiDialogsContentBase<ListViewSettingModel, void> {
    protected readonly FiDisplayType = FiDisplayType;
}
